module.exports = __webpack_public_path__ + "img/template-mobile.99572229.svg";